import {
  Box,
  Button,
  CardMedia,
  Grid,
  Badge,
  IconButton,
  Pagination,
  Stack,
  Typography,
  FormControl,
  InputLabel,
  Input,
  InputAdornment,
  Menu,
  TextField,
  useTheme,
  TablePagination,
  Theme,
} from '@mui/material';
import { CommonLayout } from '../commonComponents';
import SearchSharpIcon from '@mui/icons-material/SearchSharp';
import AddIcon from '@mui/icons-material/Add';
import { useHistory } from 'react-router';
import { ChangeEvent, useEffect, useState } from 'react';
import { getAllApplications } from '../../redux-store/actions/application';
import { useDispatch, useSelector } from 'react-redux';
import { FilterDropdown, initialFilters } from './filters';
// import { Distributor, getDistributorsListForFilters } from '../../redux-store/actions';
import { ApplicationFilterType } from '../../redux-store/types/api-types';
import { ApplicationProps } from '../../redux-store/types/api-types';
import { RootStateType } from '../../redux-store/reducers';
import React from 'react';
import { GetAllApplicantionsResponseBody } from '../../redux-store/types/application';
import { useDebounce } from '../../utils/useDebounce';
import DashboardAndApplicationsList from '../dashboard/applicationslist';
import { Formik } from 'formik';
import MFCheckbox from '../../lib/formik/Checkbox';
import { FilterIcon, PlusIcon, SearchIcon } from '../../assets/SvgIcons';
import { Filter } from '@mui/icons-material';
import { USER_ROLES } from '../../utils/constant';
import { whiteSpaceOnlyRegex } from '../../utils/regex';

interface Values {
  pan: string;
}

interface FilterProps {
  filters: ApplicationFilterType,
  open: boolean,
  handleFiltersAnchorEl: () => void,
  filtersAnchorEl: boolean,
  setPage: React.Dispatch<React.SetStateAction<number>>,
  setFilters: React.Dispatch<React.SetStateAction<ApplicationFilterType>>
  handleFiltersAnchorElClose: () => void,
  distributorLoading: boolean,
  totalFilters?: number,
  setTotalFilters?: React.Dispatch<React.SetStateAction<number>>
}


const FilterMenu = (): JSX.Element => {
  const initialValues1: Values = { pan: '' };
  const handleSubmit = (values: Values) => {
    console.log(values);
  };
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const theme = useTheme();
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <Formik initialValues={initialValues1} onSubmit={handleSubmit}>
      {({ handleSubmit }) => (
        <Box component="form" noValidate onSubmit={handleSubmit}>
          <IconButton
            sx={{ p: 0 }}
            id="filter-button"
            aria-controls="filter-menu"
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}>
            <CardMedia component="img" src="/images/filter-icon.svg" alt="Filter" />
          </IconButton>
          <Menu
            id="filter-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'filter-button',
            }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            sx={{
              '.MuiPaper-root': { p: 2, pt: 1 },
              '.MuiTypography-root': {
                fontFamily: `${theme.typography.fontFamily}`,
                fontSize: 14,
                '&.MuiTypography-body2': { color: 'primary.main', mb: 1 },
              },
              '.MuiBox-root:not(:last-of-type)': {
                position: 'relative',
                mr: 5,
                '::after': {
                  content: '""',
                  position: 'absolute',
                  top: 10,
                  right: -15,
                  width: '2px',
                  height: '100%',
                  background:
                    'linear-gradient(to bottom, rgba(0, 0, 0, 0.2),rgba(255, 255, 255, 0) )',
                },
              },
            }}>
            <Stack direction="row">
              <Box>
                <Typography variant="body2">Mode of holding</Typography>
                <MFCheckbox name="single" label="Single" />
                <MFCheckbox label="joint" name="Joint" />
              </Box>
              <Box>
                <Typography variant="body2">Status</Typography>
                <MFCheckbox name="Draft" label="Draft" />
                <MFCheckbox name="in-process" label="In Process" />
                <MFCheckbox name="completed" label="Completed" />
              </Box>
              {/* <Box>
                <Typography variant="body2">Distributor Name</Typography>
                <MFCheckbox name="distributor-name1" label="Distributor Name 1" />
                <MFCheckbox name="distributor-name2" label="Distributor Name 2" />
              </Box> */}
            </Stack>
          </Menu>
        </Box>
      )}
    </Formik>
  );
};

export default function Investors(): JSX.Element {
  const history = useHistory();
  const { palette } = useTheme()
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);
  const [applicationsList, setApplicationsList] = useState<ApplicationProps[]>([]);
  const [noOfPages, setNoPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0)
  const [limit, setLimit] = useState(10);
  const {
    page,
    search: storeSearch,
    status: storeStatus,
    applicationType: storeApplicationType,
    modeOfHolding: storeModeOfHolding,
    distributorId: storeDistributorId,
    diy: storeDIY,
    accountType: storeAccountType,
    onboardingType: storeOnboardingType,
    bseClientActivationStatus: storeBseStatus,
    applicationSentBack,
  } = useSelector((store: RootStateType) => store.paramsObj);
  const [currentPage, setPage] = useState(page);
  const [open, setOpen] = useState(false);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const [filtersAnchorEl, setFiltersAnchorEl] = useState<boolean>(false);
  // const [distributors, setDistributors] = useState<Distributor[]>([]);
  const [filters, setFilters] = useState<ApplicationFilterType>(
    initialFilters(
      role,
      applicationSentBack ? storeStatus.replace('draft', 'draft_send_back') : storeStatus,
      storeApplicationType,
      storeModeOfHolding,
      storeDistributorId,
      storeDIY,
      storeAccountType,
      storeBseStatus,
      storeOnboardingType
    )
  );
  const { applicationType, distributorId, status, modeOfHolding, diy, accountType, onboardingType, bseClientActivationStatus } = filters;
  const [search, setSearch] = useState(storeSearch);
  const debounceSearchString = useDebounce(search, 500);
  const [distributorLoading, setDistributorLoading] = useState(false);
  const [totalFilters, setTotalFilters] = useState<number>(0);
  const theme = useTheme();

  const badgeCount = ['applicationType', 'modeOfHolding', 'status', 'distributorId', 'diy', 'accountType', 'bseClientActivationStatus', 'onboardingType'].filter(
    (filterKey) => (filters[filterKey] as string[])?.length
  )?.length;

  useEffect(() => {
    // let componentIsAlive = true;

    getApplication()
    // return () => {
    //   componentIsAlive = false;
    // };
  }, [currentPage, debounceSearchString, filters]);

  const getApplication = async () => {
    setLoading(true);
    setApplicationsList([]);
    try {
      const response = (await dispatch(
        getAllApplications({
          page: currentPage,
          search,
          applicationType: applicationType.toString(),
          distributorId: distributorId.toString(),
          status: status
            .toString()
            .replace('draft_send_back', 'draft')
            .replace('draft,draft', 'draft'),
          modeOfHolding: 'single',
          applicationSentBack:
            status.includes('draft_send_back') && !status.includes('draft') ? true : null,
          diy: diy?.toString(),
          accountType: accountType?.toString(),
          bseClientActivationStatus: bseClientActivationStatus?.toString(),
          onboardingType: onboardingType?.toString(),
          rekycStatus: 'null,completed,pending,pending_from_mpower',
        })
      )) as unknown as GetAllApplicantionsResponseBody;
      // console.log('response', response)
      const { applications, pages, total, limit } = response || {};
      // if (!componentIsAlive) {
      //   return;
      // }
      setApplicationsList(applications);
      setNoPages(pages);
      setTotalCount(total)
      setLimit(limit);
      setLoading(false);

      if (response) {
        const totalAppliedFilters = (applicationType?.length || 0) + (distributorId?.length || 0) + (status?.length || 0) + (diy?.length || 0) + (accountType?.length || 0) + (onboardingType?.length || 0) + (bseClientActivationStatus?.length || 0);

        setTotalFilters(totalAppliedFilters);
      }
    } catch (e) {
      console.error((e as Error).message);
      setLoading(false);
    }
  }

  const handlePageChange = (event: ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handleSearchText = (event: ChangeEvent<HTMLInputElement>) => {
    const searchedText = event.target.value.replace(/^\s+/g, '').replace(/\s+/g, ' ');
    event.target.value = searchedText;
    setPage(1);
    if (whiteSpaceOnlyRegex.test(searchedText)) return;
    setSearch(event.target.value);
  }

  const handleFiltersAnchorEl = async () => {
    try {
      setFiltersAnchorEl(true);
      // setDistributorLoading(true);
      // const distributorList = (await dispatch(
      //   getDistributorsListForFilters()
      // )) as unknown as Distributor[];
      // setDistributors(distributorList);
      setDistributorLoading(false);
    } catch (e) {
      console.error((e as Error).message);
      setDistributorLoading(false);
    }
  };

  const handleFiltersAnchorElClose = () => {
    setFiltersAnchorEl(false);
  };

  return (
    <CommonLayout>
      <>
        <Box>
          {/* <Typography
            sx={{
              fontFamily: 'Poppins, sans-serif',
              fontSize: 18,
              fontWeight: 500,
              mb: { xs: 2, md: 4 },
              p: { xs: '5px 15px', md: '' },
              bgcolor: '#e5f1f8',
              borderRadius: '10px',
            }}>
            All Applications
          </Typography> */}
          <Box sx={{ marginBottom: '20px' }}>
            {/* <Typography sx={{ color: 'text.primary' }} variant='h1'>All Applications</Typography> */}
            <Typography sx={{ color: 'text.primary' }} variant='h1'>Onboarding Status</Typography>
          </Box>

          <Box
            sx={{
              borderRadius: '25px',
              overflow: 'hidden',
              backgroundColor: palette.background.paper,
              width: '100%',
              // maxWidth: { lg: '1200px', xs: '100%' },
            }}
          >
            <Grid
              container
              sx={{
                p: '35px 30px',
                pb: 0,
                justifyContent: 'space-between',
                alignItems: 'flex-end',
                bgcolor: 'common.white',
                // mb: 1.5,
              }}>
              <Grid item container sx={{ width: 'unset', alignItems: 'flex-end', gap: 2, pb: 3 }}>
                <Grid item sx={{alignSelf: 'center'}}>
                  <TextField
                    id="outlined-multiline-flexible"
                    value={search}
                    placeholder="Search Application"
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleSearchText(e)}
                    // onChange={({ target: { value } }) => {
                    //   setPage(1);
                    //   handleSearchText(value);
                    // }}
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                      style: {
                        borderRadius: '5px',
                        // background: 'red',
                        border: `1px solid ${palette.text.secondary}B2`,
                        height: '40px',
                        width: '100%',
                        maxWidth: '255px',
                        // fontSize: '16px',
                        background: 'transparent',
                        ...theme.typography.body_400
                      },
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '&.Mui-focused fieldset': {
                          borderColor: '#B2B2B2', // Change focused border color if needed
                        },
                        '&:hover fieldset': {
                          borderColor: '#B2B2B2', // Change hover border color if needed
                        },
                      },
                      '& input': {
                        backgroundColor: 'transparent', // Ensure input background is transparent
                      },
                      '& .MuiAutocomplete-option': {
                        backgroundColor: 'transparent', // Ensure options have transparent background
                        '&[aria-selected]': {
                          backgroundColor: 'transparent', // Prevent blue selection background
                          color: '#000', // Change text color if necessary
                        },
                      },
                    }}
                  />
                </Grid>
                {/* <Grid item sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 0.5 }}> */}
                {/* <Typography sx={{ fontSize: 14, fontWeight: 600, color: 'primary.main', pr: 1 }}>
                Filters :
              </Typography> 
               <Stack direction="row" gap={1} flexWrap="wrap">
                <Chip
                  label="Single"
                  size="small"
                  onDelete={() => console.log('chip deleted')}
                  sx={{
                    bgcolor: 'rgba(41, 49, 57, 0.05)',
                    //  '& .MuiChip-label': { lineHeight: 1 }
                  }}
                />
              </Stack> */}
                {/* </Grid> */}
              </Grid>
              <Grid item container sx={{ width: 'unset', alignItems: 'flex-end', gap: 2, pb: 3 }}>
                <Grid item sx={{ display: 'flex', alignItems: 'center', gap: '25px', flexDirection: 'row' }}>
                  {/* {filterOptions()} */}
                  <FilterOptions {...{ filters, open, handleFiltersAnchorEl, handleFiltersAnchorElClose, filtersAnchorEl, distributorLoading, setPage, setFilters, setFiltersAnchorEl, totalFilters, setTotalFilters }} />
                  <Button disabled={[USER_ROLES.AMC_ADMIN].includes(role)} style={{ height: '40px', background: palette.primary[500], borderRadius: '4px', width: '100%', padding: '12px', gap: '12px', opacity: [USER_ROLES.AMC_ADMIN].includes(role) ? 0.5 : 1 }}
                    onClick={() => history.push('/onboarding')}>
                    <PlusIcon />
                    {/* <Typography style={{ color: palette.textDark.primary, fontWeight: 500 }}>Add Applicant</Typography> */}
                    <Typography variant='body_400' style={{ color: palette.textDark.primary, fontWeight: 500 }}>Create Onboarding</Typography>
                  </Button>
                </Grid>
                <Grid item>{/* <FilterMenu /> */}</Grid>
              </Grid>
            </Grid>

            <Box sx={{
              width: '100%',
              overflowX: 'auto'
            }}>
              <DashboardAndApplicationsList
                isLoading={isLoading}
                applicationsList={applicationsList ?? []}
                boxStyles={{ minWidth: 100 }}
                getApplication={getApplication}
              />

            </Box>
            {!!applicationsList?.length && (
              <TablePagination
                style={{
                  color: palette.text.primary[500],
                  fontSize: 16,
                  fontWeight: 500,
                  padding: '20px 35px 35px 35px',
                  // paddingLeft: '50px',
                  // paddingBottom: '48px'
                }}
                rowsPerPageOptions={[]}
                labelRowsPerPage=""
                component="div"
                count={totalCount}
                rowsPerPage={limit}
                page={currentPage - 1}
                onPageChange={(event, num) => setPage(num + 1)}
                // onRowsPerPageChange={(rowsPerPage) => console.log('rowsPerPage', rowsPerPage.target.value)}
                sx={{
                  color: palette.text.primary[500]
                }} />
              // <Stack direction="row" justifyContent="center" sx={{ mt: 5 }}>
              //   <Pagination
              //     count={noOfPages}
              //     page={currentPage}
              //     color="primary"
              //     onChange={handlePageChange}
              //   />
              // </Stack>
            )}
          </Box>

          {/* {!!applicationsList.length && (
            <Stack direction="row" justifyContent="center" sx={{ mt: 5 }}>
              <Pagination
                count={noOfPages}
                page={currentPage}
                color="primary"
                onChange={handlePageChange}
              />
            </Stack>
          )} */}
        </Box>
      </>
    </CommonLayout>
  );
}

const FilterOptions = (props: FilterProps): JSX.Element => {
  const { filters, open, handleFiltersAnchorEl, filtersAnchorEl, setPage, setFilters, handleFiltersAnchorElClose, distributorLoading, totalFilters, setTotalFilters } = props;
  const { palette } = useTheme()
  const badgeCount = ['applicationType', 'modeOfHolding', 'status', 'distributorId', 'diy', 'accountType', 'bseClientActivationStatus', 'onboardingType'].filter(
    (filterKey) => (filters[filterKey] as string[])?.length
  )?.length;
  // console.log('filtersAnchorEl', filtersAnchorEl)
  return (
    <>
      <Box
        // aria-controls="filter-menu"
        // aria-haspopup="true"
        // aria-expanded={open ? 'true' : undefined}
        component={'button'}
        sx={{ display: 'flex', alignItems: 'center', gap: '10px', border: 'none', background: 'transparent', cursor: 'pointer' }} onClick={handleFiltersAnchorEl}>

        <Badge
          showZero
          badgeContent={totalFilters}
          sx={(theme: Theme) => ({
            '& .MuiBadge-badge': {
              right: 0,
              top: -3,
              backgroundColor: theme.palette.primary[500],
              color: theme.palette.common.white,
              ...theme.typography.subtitle_600
            },
          })}
        >
          <FilterIcon />
        </Badge>
        <Typography variant='body_400' sx={{ fontWeight: 500, color: palette.text.primary }}>Filters</Typography>
      </Box>
      {filtersAnchorEl && (
        <FilterDropdown
          filters={filters}
          onFiltersChange={(value) => {
            setPage(1);
            setFilters(value);
          }}
          anchorEl={filtersAnchorEl}
          handleClose={handleFiltersAnchorElClose}
          // distributors={distributors}
          loader={distributorLoading}
          setTotalFilters={setTotalFilters}
        />

      )}
    </>
  );
};


